import React from 'react';
import { initI18n, useTranslation, I18nextProvider, } from '@wix/wix-i18n-config';
import { ExternalTranslationsContext, useApi } from '@wix/comments-ooi-client';
let i18n;
const icuOptions = {
    formats: {
        date: {
            wcShortDate: { month: 'short', day: '2-digit' },
            wcFullDate: { month: 'short', day: '2-digit', year: 'numeric' },
        },
    },
};
export default function WixCommentsTranslationsProvider(props) {
    const [locale = 'en', messages, wcBaseParams] = useApi((state) => [
        state.baseParams?.language,
        state.translations,
        state.baseParams,
    ]);
    if (!wcBaseParams) {
        // this means that controller is not yet initialized
        return React.createElement(React.Fragment, null, props.children);
    }
    i18n =
        i18n ||
            initI18n({
                locale,
                messages,
                icuOptions,
            });
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(ExternalTranslationsProviderInner, null, props.children)));
}
function ExternalTranslationsProviderInner(props) {
    const [t] = useTranslation();
    return (React.createElement(ExternalTranslationsContext.Provider, { value: React.useMemo(() => ({
            t,
        }), [t]) }, props.children));
}
//# sourceMappingURL=translations-provider.js.map